<template>
  <b-toast
    id="shopify-basket"
    :toaster="blok.position"
    :variant="blok.style"
    solid
    no-close-button
    auto-hide-delay="10000"
  >
    <b-row>
      <b-col sm="12" :class="blok.message_styles">{{ message }}</b-col>
      <b-col sm="12" v-if="link">
        <a :href="link" class="btn btn-primary btn-block">{{ linkText }}</a>
      </b-col>
    </b-row>
  </b-toast>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
    name: 'shopify-delivery-alert',
    props: {
        blok: Object
    },
    watch: {
        basket: function(val) {
            this.$bvToast.show('shopify-basket');
        }
    },
    computed: {
        ...mapState({
            basket: state => state.shopify.checkout
        }),
        message: function() {
            const f = this.$options.filters;
            if(!this.basket){
                return '';
            }
            if(this.basket.lineItems.length==0) {
                return this.blok.zero_items_message;
            } else if(Number(this.basket.paymentDue)<this.blok.min_value) {
                return this.blok.low_value_message
                    .replace('%%total%%', f.currency(this.basket.paymentDue))
                    .replace('%%remaining%%', f.currency(Number(this.blok.min_value) - Number(this.basket.paymentDue)));
            } 
            return this.blok.valid_message;
        },
        link: function() {
            const f = this.$options.filters;
            if(!this.basket){
                return '';
            }
            if(this.basket.lineItems.length==0) {
                return this.blok.zero_link.cached_url ? f.formatSbInternalLink(this.blok.zero_link.cached_url) : null;
            } 
            return this.blok.basket_link.cached_url ? f.formatSbInternalLink(this.blok.basket_link.cached_url) : null;
        },
        linkText: function() {
            const f = this.$options.filters;
            if(!this.basket){
                return '';
            }
            if(this.basket.lineItems.length==0) {
                return this.blok.zero_link_text;
            } 
            return this.blok.basket_link_text;
        }
    },
    mounted: function() {
        this.$bvToast.show('shopify-basket');
    }
}
</script>